/* eslint-disable class-methods-use-this */
import ReduceStore from "flux/lib/FluxReduceStore";
import { AllPayloads } from "../payloads";
import ElectronActionTypes from "./ElectronActionTypes";

interface State {
    fullScreen: boolean;
    isMaximized: boolean;
}

class ElectronStore extends ReduceStore<State, AllPayloads> {
    getInitialState(): State {
        return {
            fullScreen: false,
            isMaximized: false
        };
    }

    setFullScreen(state: State, fullScreen: boolean): State {
        return {
            ...state,
            fullScreen
        };
    }

    setWindowMaximized(state: State, isMaximized: boolean): State {
        return {
            ...state,
            isMaximized
        };
    }

    reduce(state: State, action: AllPayloads): State {
        switch (action.type) {
            case ElectronActionTypes.SET_FULL_SCREEN:
                return this.setFullScreen(state, action.fullScreen);
            case ElectronActionTypes.SET_WINDOW_MAXIMIZED:
                return this.setWindowMaximized(state, action.isMaximized);
            default:
                return state;
        }
    }
}

export default ElectronStore;
export { State as ElectronStoreState };
